const MOBILE_SEARCH_PLACEHOLDER_BREAKPOINT = 430;
const RESPONSIVE_SEARCH_SELECTOR =
  'input[type="search"][data-placeholder-default][data-placeholder-mobile]';

function applyResponsiveSearchPlaceholders() {
  const useMobilePlaceholder =
    window.innerWidth < MOBILE_SEARCH_PLACEHOLDER_BREAKPOINT;

  document.querySelectorAll(RESPONSIVE_SEARCH_SELECTOR).forEach((input) => {
    const placeholder = useMobilePlaceholder
      ? input.dataset.placeholderMobile
      : input.dataset.placeholderDefault;

    if (placeholder) input.setAttribute('placeholder', placeholder);

    const label = input.closest('.field')?.querySelector('.field__label');
    if (!label) return;

    const labelText = useMobilePlaceholder
      ? input.dataset.labelMobile || input.dataset.placeholderMobile
      : input.dataset.labelDefault || input.dataset.placeholderDefault;

    if (labelText) label.textContent = labelText;
  });
}

let responsiveSearchPlaceholdersInitialized = false;

function setupResponsiveSearchPlaceholders() {
  if (responsiveSearchPlaceholdersInitialized) return;
  responsiveSearchPlaceholdersInitialized = true;

  applyResponsiveSearchPlaceholders();
  window.addEventListener('resize', applyResponsiveSearchPlaceholders);
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    setupResponsiveSearchPlaceholders,
    { once: true }
  );
} else {
  setupResponsiveSearchPlaceholders();
}

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
